import { Upload } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const UploadIcon = createLucideIcon(Upload);
